import { isApiErrorParams } from './apiError';
import { ErrorHandler, ThrownError } from './errorHandler';
import { AppError } from '../../types/appError';

class ApiErrorHandler implements ErrorHandler {

  public handleError(error: ThrownError, errorMessage: string): never {
    const appError: AppError = this.mapToAppError(error, errorMessage);

    throw appError;
  }

  private mapToAppError(error: ThrownError, errorMessage: string): AppError {
    if (isApiErrorParams(error)) {
      return {
        error: errorMessage,
        message: `Api responses with the '${error.error}' error and '${error.status}' status`,
        timestamp: error.timestamp,
        details: error.details,
      };
    }

    return {
      error: errorMessage,
      message: error.message,
      timestamp: new Date().toISOString(),
    };
  }
}

export default new ApiErrorHandler();
